/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
import constants from './constants';
import React from 'react';
import Label from '../components/Label';
import toast from 'react-hot-toast';
import userService from '../services/userService';
import commonService from '../services/commonService';
import { draftOptions, siteOptions } from '../constants';
import { isFinite } from 'lodash';
import i18next from 'i18next';

const baseUrl = process.env.REACT_APP_BASE_URL;

const helpers = {
  authorizedHeader: () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.token) {
      return { 'Content-Type': 'application/json', Authorization: `Bearer ${user.token}` };
    }
    return { 'Content-Type': 'application/json' };
  },
  getUser: () => {
    const user = localStorage.getItem('user');

    if (user) {
      return JSON.parse(user);
    }
    return {};
  },
  getRole: () => {
    const role = localStorage.getItem('role');

    if (role) {
      return parseInt(role, 10);
    }
    return constants.role.buyer;
  },
  setRole: (role) => {
    localStorage.setItem('role', role);
  },
  validateVKN: (kno) => {
    if (kno && kno.length === 10) {
      const v = [];
      const lastDigit = Number(kno.charAt(9));
      for (let i = 0; i < 9; i++) {
        const tmp = (Number(kno.charAt(i)) + (9 - i)) % 10;
        v[i] = (tmp * 2 ** (9 - i)) % 9;
        if (tmp !== 0 && v[i] === 0) v[i] = 9;
      }
      const sum = v.reduce((a, b) => a + b, 0) % 10;
      return (10 - (sum % 10)) % 10 === lastDigit;
    }
    return false;
  },
  createRequesterOptions: (url, type, model, contentType) => {
    const config = {
      url,
      method: type,
      baseURL: baseUrl,
      headers: helpers.authorizedHeader(),
    };

    if (contentType) {
      config.headers['Content-Type'] = contentType;
    }

    if (type === constants.requestType.post && model) {
      config.data = model;
    } else if (model) {
      config.params = model;
    }
    return config;
  },
  getPictureUrl: (url) => `${process.env.REACT_APP_BASE_URL_PURE}${url}`,
  // getPictureUrl: (url) => !url.includes('null') ? `${process.env.REACT_APP_BASE_URL_PURE}${url}` : null,
  // getPictureUrl: (url) => {
  //   if (!url.includes('null')) {
  //     return `${process.env.REACT_APP_BASE_URL_PURE}${url}`;
  //   }
  //   return null;
  // },
  getStatusLabel: (paymentStatus) => {
    const map = {
      canceled: {
        color: 'error',
        text: 'Canceled'
      },
      completed: {
        color: 'success',
        text: 'Completed'
      },
      pending: {
        color: 'warning',
        text: 'Pending'
      },
      rejected: {
        color: 'error',
        text: 'Rejected'
      }
    };

    const { text, color } = map[paymentStatus];

    return (
      <Label color={color}>
        {text}
      </Label>
    );
  },
  groupBy: (arr, key) => arr.reduce((acc, val) => {
    if (!acc[val[key]]) {
      acc[val[key]] = {};
      acc[val[key]] = [];
    }
    acc[val[key]].push(val);
    return acc;
  }, {}),
  timeDifference: (current, previous) => {
    if (!previous) {
      return '-';
    }
    const msPerMinute = 60 * 1000;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;
    const msPerMonth = msPerDay * 30;
    const msPerYear = msPerDay * 365;

    const elapsed = current - previous;

    if (elapsed < msPerMinute) {
      return i18next.t('TimeDifference.seconds_ago', { count: Math.round(elapsed / 1000) });
    }

    if (elapsed < msPerHour) {
      return i18next.t('TimeDifference.minutes_ago', { count: Math.round(elapsed / msPerMinute) });
    }

    if (elapsed < msPerDay) {
      return i18next.t('TimeDifference.hours_ago', { count: Math.round(elapsed / msPerHour) });
    }

    if (elapsed < msPerMonth) {
      return i18next.t('TimeDifference.days_ago', { count: Math.round(elapsed / msPerDay) });
    }

    if (elapsed < msPerYear) {
      return i18next.t('TimeDifference.months_ago', { count: Math.round(elapsed / msPerMonth) });
    }

    return i18next.t('TimeDifference.years_ago', { count: Math.round(elapsed / msPerYear) });
  },
  getCities: () => [{ id: 0, name: i18next.t('Filters.city.all') }, { id: 1, name: 'Adana' }, { id: 2, name: 'Adıyaman' }, { id: 3, name: 'Afyonkarahisar' }, { id: 4, name: 'Ağrı' }, { id: 5, name: 'Amasya' }, { id: 6, name: 'Ankara' }, { id: 7, name: 'Antalya' }, { id: 8, name: 'Artvin' }, { id: 9, name: 'Aydın' }, { id: 10, name: 'Balıkesir' }, { id: 11, name: 'Bilecik' }, { id: 12, name: 'Bingöl' }, { id: 13, name: 'Bitlis' }, { id: 14, name: 'Bolu' }, { id: 15, name: 'Burdur' }, { id: 16, name: 'Bursa' }, { id: 17, name: 'Çanakkale' }, { id: 18, name: 'Çankırı' }, { id: 19, name: 'Çorum' }, { id: 20, name: 'Denizli' }, { id: 21, name: 'Diyarbakır' }, { id: 22, name: 'Edirne' }, { id: 23, name: 'Elazığ' }, { id: 24, name: 'Erzincan' }, { id: 25, name: 'Erzurum' }, { id: 26, name: 'Eskişehir' }, { id: 27, name: 'Gaziantep' }, { id: 28, name: 'Giresun' }, { id: 29, name: 'Gümüşhane' }, { id: 30, name: 'Hakkari' }, { id: 31, name: 'Hatay' }, { id: 32, name: 'Isparta' }, { id: 33, name: 'Mersin' }, { id: 34, name: 'İstanbul' }, { id: 35, name: 'İzmir' }, { id: 36, name: 'Kars' }, { id: 37, name: 'Kastamonu' }, { id: 38, name: 'Kayseri' }, { id: 39, name: 'Kırklareli' }, { id: 40, name: 'Kırşehir' }, { id: 41, name: 'Kocaeli' }, { id: 42, name: 'Konya' }, { id: 43, name: 'Kütahya' }, { id: 44, name: 'Malatya' }, { id: 45, name: 'Manisa' }, { id: 46, name: 'Kahramanmaraş' }, { id: 47, name: 'Mardin' }, { id: 48, name: 'Muğla' }, { id: 49, name: 'Muş' }, { id: 50, name: 'Nevşehir' }, { id: 51, name: 'Niğde' }, { id: 52, name: 'Ordu' }, { id: 53, name: 'Rize' }, { id: 54, name: 'Sakarya' }, { id: 55, name: 'Samsun' }, { id: 56, name: 'Siirt' }, { id: 57, name: 'Sinop' }, { id: 58, name: 'Sivas' }, { id: 59, name: 'Tekirdağ' }, { id: 60, name: 'Tokat' }, { id: 61, name: 'Trabzon' }, { id: 62, name: 'Tunceli' }, { id: 63, name: 'Şanlıurfa' }, { id: 64, name: 'Uşak' }, { id: 65, name: 'Van' }, { id: 66, name: 'Yozgat' }, { id: 67, name: 'Zonguldak' }, { id: 68, name: 'Aksaray' }, { id: 69, name: 'Bayburt' }, { id: 70, name: 'Karaman' }, { id: 71, name: 'Kırıkkale' }, { id: 72, name: 'Batman' }, { id: 73, name: 'Şırnak' }, { id: 74, name: 'Bartın' }, { id: 75, name: 'Ardahan' }, { id: 76, name: 'Iğdır' }, { id: 77, name: 'Yalova' }, { id: 78, name: 'Karabük' }, { id: 79, name: 'Kilis' }, { id: 80, name: 'Osmaniye' }, { id: 81, name: 'Düzce' }],
  getPaymentTypes: () => [
    { id: 1, name: i18next.t('Filters.paymentType.cash'), type: 'paymentTypeList' },
    { id: 2, name: i18next.t('Filters.paymentType.cheque'), type: 'paymentTypeList' },
    { id: 3, name: i18next.t('Filters.paymentType.creditCard'), type: 'paymentTypeList' },
    { id: 4, name: i18next.t('Filters.paymentType.termAccount'), type: 'paymentTypeList' }],
  validateTCKN: (value) => {
    if (!value) {
      return false;
    }
    value = value.toString();
    const isEleven = /^[0-9]{11}$/.test(value);
    let totalX = 0;
    for (let i = 0; i < 10; i++) {
      totalX += Number(value.substr(i, 1));
    }
    // eslint-disable-next-line eqeqeq
    const isRuleX = totalX % 10 == value.substr(10, 1);
    let totalY1 = 0;
    let totalY2 = 0;
    for (let i = 0; i < 10; i += 2) {
      totalY1 += Number(value.substr(i, 1));
    }
    for (let i = 1; i < 10; i += 2) {
      totalY2 += Number(value.substr(i, 1));
    }
    // eslint-disable-next-line eqeqeq
    const isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9, 0);
    return isEleven && isRuleX && isRuleY;
  },
  copyInviteLink: (token) => {
    navigator.clipboard.writeText(`${window.location.origin}/register?ref=${token}`).then(() => {
      toast.success('GFR linki kopyalandı.');
    }).catch((err) => {
      console.log(err);
      toast.error('Kopyalanamadı');
    });
  },
  copyInviteText: (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('GFR metni kopyalandı.');
    }).catch((err) => {
      console.log(err);
      toast.error('Kopyalanamadı');
    });
  },
  notificationToUrl: {
    DEPOSIT: () => '#',
    NEW_BID_RESPONSE: (notify) => `/orders/${notify.jsonData?.bidRequestId || ''}`,
    NEW_BID_MATCH: (notify) => `/bids/${notify.jsonData?.bidRequestId || ''}`,
    NEW_MESSAGE: () => '#',
    NEW_BID_MATCH_RATE: () => '/account?tab=profile',
    NEW_REFERENCE_REQUEST: () => 'account?tab=references',
    APPROVE_REFERENCE: () => 'account?tab=references',
    BID_ENDING_ANNOUNCEMENT: (notify) => `/bids/${notify.jsonData?.bidRequestId || '0'}`,
    CANCEL_BID_RESPONSE: (notify) => `/orders/${notify.jsonData?.bidRequestId || '0'}`,
    CANCEL_BID_REQUEST: (notify) => `/bids/${notify.jsonData?.bidRequestId || '0'}`,
    // CANCEL_BID_REQUEST: (notify) => `/bids/${notify.jsonData?.bidResponseId || ''}`,
  },
  nameToTitle: (arr) => {
    const newArr = [];

    arr.map((row) => newArr.push({ ...row, title: row.name }));

    return newArr;
  },
  checkIsMaster: (setResponse) => userService.checkUserIsMaster()
    .then((response) => {
      setResponse(response);
    }),
  getSectors: async () => {
    let sectors = [];
    const response = await commonService.getSectors();
    if (response) {
      response.forEach((sec) => {
        sec.type = 'sectorList';
      });
      sectors = response;
    }
    return sectors;
  },
  getSiteOptions: (key) => {
    const siteOptionsObj = JSON.parse(localStorage.getItem(siteOptions) || '{}');
    if (key) {
      return siteOptionsObj[key];
    }
    return siteOptionsObj;
  },
  setSiteOptions: (key, value) => {
    const siteOptionsObj = JSON.parse(localStorage.getItem(siteOptions) || '{}');
    siteOptionsObj[key] = value;
    localStorage.setItem(siteOptions, JSON.stringify(siteOptionsObj));
  },
  getOptions: (optionName, key) => {
    const siteOptionsObj = JSON.parse(localStorage.getItem(optionName) || '{}');
    if (key) {
      return siteOptionsObj[key];
    }
    return null;
  },
  setOptions: (optionName, key, value) => {
    const siteOptionsObj = JSON.parse(localStorage.getItem(optionName) || '{}');
    siteOptionsObj[key] = value;
    localStorage.setItem(optionName, JSON.stringify(siteOptionsObj));
  },
  checkPermission: (permission, navigate, message = 'Bu sayfayı görüntülemeye yetkiniz yok') => {
    if (permission !== true) {
      toast.error(message);
      navigate('/');
    }
  },
  getChipsFromParams: (fs, params) => {
    const ch = [];
    const paymentTypes = helpers.getPaymentTypes();
    const cities = helpers.getCities();
    Object.entries(fs)
      // eslint-disable-next-line no-unused-vars
      .filter(([_, value]) => !!value)
      .forEach(([key, value]) => {
        try {
          if (key === 'paymentTypeList' || key === 'cityList' || key === 'bidRequestGroup') {
            if (Array.isArray(value)) {
              value.forEach((val) => {
                ch.push({
                  id: Number(val),
                  type: key,
                  name: key === 'paymentTypeList' ? paymentTypes.find((pt) => pt.id == val)?.name : (key === 'cityList' ? (cities.find((cty) => cty.id == val)?.name ?? '') : Array.isArray(params?.bidRequestGroup) ? params?.bidRequestGroup.find((br) => br.id == val).name : '')
                });
              });
            } else {
              ch.push({
                id: Number(value),
                type: key,
                name: key === 'paymentTypeList' ? paymentTypes.find((pt) => pt.id == value)?.name : (key === 'cityList' ? (cities.find((cty) => cty.id == value)?.name ?? '') : Array.isArray(params?.bidRequestGroup) ? params?.bidRequestGroup.find((br) => br.id == value).name : '')
              });
            }
          } else if (key === constants.filterType.deliveryTime || key === constants.filterType.bidRequestDate || key === constants.filterType.responseDate) {
            const dates = {};
            dates.from = value[0] && new Date(value[0]) instanceof Date && isFinite(new Date(value[0]).getTime()) ? new Date(value[0]) : null;
            dates.to = value[1] && new Date(value[1]) instanceof Date && isFinite(new Date(value[1]).getTime()) ? new Date(value[1]) : null;
            ch.push({
              type: key,
              name: `${helpers.getFilterTypeNames(key)} ${dates.from?.toLocaleDateString(constants.defaultCulture) || ''} - ${dates.to?.toLocaleDateString(constants.defaultCulture) || ''}`,
              from: dates.from,
              to: dates.to
            });
          } else if (key === constants.filterType.quantity) {
            const [min, max, measurementUnit] = value.split('-');
            const measurementUnitModel = constants.measurementUnit.find((mea) => mea.value == measurementUnit);
            ch.push({
              id: value,
              type: key,
              name: `${Number.isNaN(parseFloat(min)) ? '(0)' : parseFloat(min)} - ${Number.isNaN(parseFloat(max)) ? '' : parseFloat(max)} ${measurementUnitModel?.label}`,
              min: Number.isNaN(parseFloat(min)) ? null : parseFloat(min),
              max: Number.isNaN(parseFloat(max)) ? null : parseFloat(max),
              measurementUnit: measurementUnitModel.value,
              measurementUnitName: measurementUnitModel?.label
            });
          } else if (key === 'productId') {
            const [valId, name] = value.split('-');
            ch.push({ id: 800, valId: Number(valId), type: key, name: `${helpers.getFilterTypeNames(key)} ${name}` });
          } else if (Object.keys(constants.checkboxFilterModel).includes(key)) {
            ch.push({ id: value, valId: value, type: key, name: helpers.getFilterTypeNames(key) });
          } else if (key === 'createdUser' || key === 'authorizedUser') {
            ch.push({ id: value, valId: value, type: key, name: `${helpers.getFilterTypeNames(key)} ${value}`, valueLabels: [value] });
          } else if (key === 'bidPreRequestStatus') {
            if (Array.isArray(value)) {
              const valueLabels = value.filter((v) => !!constants.bidPreRequestStatus[v])
                .map((v) => constants.bidPreRequestStatus[v]?.text);

              ch.push({ valueLabels, valId: value, id: value, value, type: key, name: `${helpers.getFilterTypeNames(key)} ${valueLabels.join(', ')}` });
            }
          } else {
            ch.push({ valueLabels: [value], id: value, valId: value, type: key, name: `${helpers.getFilterTypeNames(key)} ${value}` });
          }
        } catch (error) {
          console.log(error);
        }
      });
    return ch;
  },
  getFilterTypeNames: (type) => {
    const filterTypes = {
      quantity: i18next.t('Filters.quantity'),
      deliveryTime: i18next.t('Filters.deliveryTime'),
      responseDate: i18next.t('Filters.responseDate'), // Teklif tatihi
      bidRequestDate: i18next.t('Filters.bidRequestDate'), // Oluşturulma tarihi
      insertDate: i18next.t('Filters.insertDate'), // PaymentBilling
      product: i18next.t('Filters.product'),
      productId: i18next.t('Filters.productId'),
      brand: i18next.t('Filters.brand'),
      bidDetail: i18next.t('Filters.bidDetail'),
      activityArea: i18next.t('Filters.activityArea'),
      getFavCompany: i18next.t('Filters.getFavCompany'),
      getHiddenBids: i18next.t('Filters.getHiddenBids'),
      getFavCompanyBids: i18next.t('Filters.getFavCompanyBids'),
      getMyFavCompany: i18next.t('Filters.getMyFavCompany'),
      getDiscardBid: i18next.t('Filters.getDiscardBid'),
      getWatchedBid: i18next.t('Filters.getWatchedBid'),
      getAllBidRequests: i18next.t('Filters.getAllBidRequests'),
      authorizedUser: i18next.t('Filters.authorizedUser'),
      createdUser: i18next.t('Filters.createdUser'),
      bidPreRequestStatus: i18next.t('Filters.bidPreRequestStatus')
    };

    return filterTypes[type] ?? ' ';
  },
  getDrafts: () => {
    const defaultDrafts = {
      excelDrafts: [],
    };
    const drafts = JSON.parse(localStorage.getItem(draftOptions) || JSON.stringify(defaultDrafts));

    return drafts;
  },
  setDraft: (key, draftModel) => {
    const drafts = helpers.getDrafts();
    if (!drafts[key]) {
      drafts[key] = [];
    }

    drafts[key].push(draftModel);

    localStorage.setItem(draftOptions, JSON.stringify(drafts));
  },
};
export default helpers;
